import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import auth from '../../utils/auth'
import apiService from '../api/service'
import adapter from './adapter'
import accountService from './service'
const { getAccountTypeId } = auth()

const NAME = 'account'

const initialState = {
  _payload: null,
  status: 'idle',
  error: '',
  isLoggedIn: false,
  isIndividu: false,
  isOfficial: false,
  isVerified: false,
  data: {
    individu: []
  },
  profile: {},
  profileInitialForm: {},
  resetPasswordStep: 1,

  status_tickets: 'idle',
  tickets: [],
  showAuth: false,
  popupContent: 'login'
}

// Define a thunk that dispatches those action creators
export const fetchAccount = createAsyncThunk(`${NAME}/fetchAccount`, async (dispatch) => {
  // make an async call in the thunk
  const account = await accountService.getAccount()
  return account
})

export const requestOTP = createAsyncThunk(`${NAME}/requestOTP`, async ({email, method}) => {
  const requestBody = { email, method }
  return await apiService.post('otp', requestBody)
})

export const requestOTPVerification = createAsyncThunk(`${NAME}/requestOTPVerification`, async ({email, method}) => {
  const requestBody = { email, method }
  return await apiService.post('otp_verification', requestBody)
})

export const requestOTPForgotPassword = createAsyncThunk(`${NAME}/requestOTPForgotPassword`, async ({email, method}) => {
  const requestBody = { email, method }
  return await apiService.post('otp_forgot_password', requestBody)
})

export const resetPassword = createAsyncThunk(`${NAME}/resetPassword`, async ({otp, password}) => {
  const requestBody = { otp, password }
  return await apiService.post('forgot_password', requestBody)
})

export const changeEmail = createAsyncThunk(`${NAME}/changeEmail`, async ({id, email}) => {
  const requestBody = { email }

  return await apiService.update('account', id, requestBody)
})

export const changePassword = createAsyncThunk(`${NAME}/changePassword`, async ({oldPassword, newPassword}) => {
  const requestBody = { oldPassword, newPassword }
  return await apiService.post('change_password', requestBody)
})

export const fetchTickets = createAsyncThunk(`${NAME}/fetchTickets`, async () => {
  return await apiService.get('individu_tickets')
})

export const setShowAuth = createAsyncThunk(`${NAME}/setShowAuth`, async (options) => {
  return options
})

export const accountSlice = createSlice({
  name: 'account',
  initialState,
  reducers: {
    getName: (state) => state.data.individu[0].namaIndividu,
    reset: () => initialState,
    setResetPasswordStep: (state, action) => {
      state.resetPasswordStep = action.payload
    },
    setPopupContent: (state, action) => {
      state.popupContent = action.payload
    }
  },
  extraReducers: {
    [fetchAccount.pending]: (state) => {
      state.status = 'loading'
    },
    [fetchAccount.fulfilled]: (state, action) => {
      state.status = 'succeeded'
      state._payload = action.payload

      /**
       * @note 2020/10/15
       * Response dari API itu array berisi 1 object,
       * bukan langsung object-nya.
       * Jadi, cara akses datanya: action.payload[0]
       */
      const account = action.payload[0]

      state.data = account
      state.isLoggedIn = true

      const isIndividuAccount = getAccountTypeId(account) === 1
      const isOrganizationAccount = getAccountTypeId(account) === 2
      state.isIndividu = isIndividuAccount
      state.isOfficial = isOrganizationAccount

      let isVerified = false

      if(isIndividuAccount){
        state.profile = adapter.accountToIndividuProfile(account)
        state.profileInitialForm = adapter.accountToIndividuProfileInitialForm(account)

        // Check verification status
        const { individu } = account
        const firstIndividu = individu ? individu[0] : false
        if(firstIndividu)
        isVerified = firstIndividu.statusIndividu?.id === 2
      }

      if(isOrganizationAccount){
        state.profile = adapter.accountToOrganizationProfile(account)
        state.profileInitialForm = adapter.accountToOrganizationProfileInitialForm(account)
      }

      state.isVerified = isVerified
    },
    [fetchAccount.rejected]: (state, action) => {
      state.status = 'failed'
      state.error = action.error.message

      if(
        action.error && (
          action.error.message === '{"detail":"Signature has expired."}'
          || action.error.message === '{"detail":"Invalid signature."}'
          || action.error.message.includes('signature')
          || action.error.message.includes('Signature')
        )
      ){
        auth().logout()
        window.location.reload()
      }
    },

    [fetchTickets.pending]: (state) => {
      state.status_tickets = 'loading'
    },
    [fetchTickets.fulfilled]: (state, action) => {
      state.status_tickets = 'succeeded'
      state.tickets = adapter.responseBodyToTickets(action.payload.result)
    },
    [fetchTickets.rejected]: (state) => {
      state.status_tickets = 'failed'
    },

    [setShowAuth.fulfilled]: (state, action) => {
      state.showAuth = action.payload
    }
  }
})

// Extract the action creators object and the reducer
const { actions, reducer } = accountSlice

// Extract and export each action creator by name
export const {
  reset,
  getName,
  setResetPasswordStep,
  setPopupContent
} = actions

// Export the reducer, either as a default or named export
export default reducer
